module.exports = __webpack_public_path__ + "img/pexels-pixabay-433942.f14d9cac.jpg";